export const AcademicoTurmas = {
    // Letra A:
    ADICIONAR_DISCIPLINA: 'Adicione disciplinas à turma',

    // Letra E:
    EDITAR_DISCIPLINA: 'Editar Disciplina',
    EDITAR_TURMA: 'Editar Turma',

    // Letra N:
    NOVA_TURMA: 'Nova Turma',

    // Letra T:
    TURMA_DESCRICAO_EDITAR: 
        'Nessa tela você pode atualizar os dados da turma',
    TURMA_DESCRICAO_NOVO: 
        "Criar uma turma é simples! Preencha o formulário abaixo e depois clique no botão 'salvar' ao final:",
}